import { render, staticRenderFns } from "./Legals.vue?vue&type=template&id=0419b046"
var script = {}
import style0 from "./Legals.vue?vue&type=style&index=0&id=0419b046&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports